import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // INTENT: Manage Web Awesome theme mode detection (Light vs Dark), system preference listeners, and optional theme toggle actions via Stimulus.
  // EXPECTED OUTCOME: Automatically applies wa-dark to html element based on system settings or localStorage overrides, and handles toggle button actions.
  // CAVEAT/TRAP: Must clean up system media query listeners on disconnect to prevent memory leaks during Turbo page navigation.
  connect() {
    this.applyScheme(this.preferredScheme)

    this.handleSystemChange = (event) => {
      if (!localStorage.getItem("wa-color-scheme")) {
        this.applyScheme(event.matches)
      }
    }

    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this.mediaQuery.addEventListener("change", this.handleSystemChange)
  }

  disconnect() {
    if (this.mediaQuery && this.handleSystemChange) {
      this.mediaQuery.removeEventListener("change", this.handleSystemChange)
    }
  }

  // INTENT: Provide a Stimulus action for theme toggle buttons (e.g. data-action="click->wa-theme#toggle").
  // EXPECTED OUTCOME: Flips between light and dark mode and saves the choice in localStorage.
  // CAVEAT/TRAP: Setting localStorage overrides system preference until cleared by user.
  toggle() {
    const isDark = !document.documentElement.classList.contains("wa-dark")
    this.applyScheme(isDark)
    localStorage.setItem("wa-color-scheme", isDark ? "dark" : "light")
  }

  applyScheme(dark) {
    document.documentElement.classList.toggle("wa-dark", dark)
  }

  get preferredScheme() {
    const savedMode = localStorage.getItem("wa-color-scheme")
    if (savedMode !== null) return savedMode === "dark"
    return window.matchMedia("(prefers-color-scheme: dark)").matches
  }
}
